// extracted by mini-css-extract-plugin
export var consumerCta = "blog-bof-cta-module--consumerCta--3c979";
export var container = "blog-bof-cta-module--container--a4fff";
export var contentContainer = "blog-bof-cta-module--contentContainer--c908a";
export var ctaContainer = "blog-bof-cta-module--ctaContainer--2bcaf";
export var headerContainer = "blog-bof-cta-module--headerContainer--3aa18";
export var headerContent = "blog-bof-cta-module--headerContent--8526b";
export var providerCta = "blog-bof-cta-module--providerCta--bf45c";